//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Form from 'vform'
import { mapGetters, mapState } from 'vuex'
import dayjs from '~/modules/dayjs'
import veeValidate from '~/mixins/veeValidate'
import { capitalizeFirstLetter } from '~/utils/utils'
import searchInput from '~/mixins/search/search-input'
import searchLocationInput from '~/components/search/search-location-input.vue'
import { SEARCH_OTHER_PAGES, SEARCH_PAGES } from '~/utils/search/search.constants'
import arrayToString from '~/filters/arrayToString'
import { isValidDateFormat } from '~/utils/v'

export default {
  name: 'SearchBarForm',
  components: { searchLocationInput },
  filters: {
    arrayToString
  },
  mixins: [veeValidate, searchInput],
  props: {
    term: {
      type: Array,
      default () {
        return []
      }
    },
    showErrorState: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'default'
    },
    boatTypeRequired: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      busy: {
        form: false
      },
      cleared: {
        date: false
      },
      form: new Form({
        searchInput: '',
        locations: [],
        date: null,
        boat_type: '',
        boat_type_id: null
      })
    }
  },
  computed: {
    ...mapState({
      staticBoatTypes: state => state.search.staticBoatTypes
    }),
    ...mapGetters({
      bar: 'search/bar',
      locale: 'lang/locale',
      currentCurrency: 'lang/currentCurrency',
      boatFormData: 'data/boatFormData',
      duration: 'search/duration',
      searchTerms: 'search/searchTerms',
      autocomplete: 'search/autocomplete',
      location: 'search/location',
      size: 'windowSize/windowWidth'
    }),
    getLocationNames () {
      return this.form.locations.map(i => i.name)
    },
    formRules () {
      return {
        location: 'required',
        date: 'required',
        boat_type: this.boatTypeRequired ? 'required' : ''
      }
    },
    getBoatTypeIcon () {
      const result = this.boatTypes.find(bt => bt.id === this.typeModel)?.icon
      return result || 'bt-any'
    },
    date: {
      get () {
        const end = new Date(this.$store.state.search.date + 'T00:00:00')
        end.setDate(end.getDate() + this.$store.state.search.duration)
        return {
          start: new Date(this.$store.state.search.date + 'T00:00:00'),
          end,
          min: null,
          max: null
        }
      },
      set (value) {

      }
    },
    getBoatTypeTitle () {
      return this.$Search.getAttributeValueTitle('boat_types').join(', ') || this.$t('any-types')
    },
    boatTypes () {
      return this.staticBoatTypes.map((t) => {
        return {
          ...t,
          name: t.translate ? capitalizeFirstLetter(this.$t(t.name.toLowerCase())) : t.name
        }
      })
    },
    dateModel: {
      get () {
        if (this.cleared.date) {
          return []
        }
        if (process.client) {
          const end = new Date(this.$store.state.search.date + 'T00:00:00')
          end.setDate(end.getDate() + this.$store.state.search.duration)
          return [
            new Date(this.$store.state.search.date + 'T00:00:00'),
            end
          ]
        } else {
          const end = new Date(this.$store.state.search.date)
          end.setDate(end.getDate() + this.$store.state.search.duration)
          return [
            new Date(this.$store.state.search.date),
            end
          ]
        }
      },
      set (value) {
        if (value && value[0] && !isNaN(value[0].getMonth())) {
          let m = value[0].getMonth() + 1
          m = m < 10 ? '0' + m : m
          let d = value[0].getDate()
          d = d < 10 ? '0' + d : d
          const dt = value[0].getFullYear() + '-' + m + '-' + d
          this.form.date = value
          this.$store.commit('search/SET_BAR', { condition: 'current', data: { date: value } })
          this.$store.commit('search/SET_DURATION', dayjs(value[1]).diff(dayjs(value[0]), 'day'))
          this.$store.commit('search/SET_DATE', dt)
        }
      }
    },
    typeModel: {
      get () {
        return this.form.boat_type_id || 9999
      },
      set (value) {
        this.form.boat_type_id = value || 9999
      }
    },
    getCurrentDate: app => (parsed = false) => {
      function formatDate (date) {
        const d = new Date(date)
        let month = '' + (d.getMonth() + 1)
        let day = '' + d.getDate()
        const year = d.getFullYear()

        if (month.length < 2) {
          month = '0' + month
        }
        if (day.length < 2) {
          day = '0' + day
        }

        return [day, month, year].join('/')
      }

      if (parsed && Array.isArray(app.dateModel) && app.dateModel.length === 2) {
        if (process.server) {
          return ([
            formatDate(app.dateModel[0]),
            formatDate(app.dateModel[1])
          ])
        }
        return [
          app.$options.filters.formattedDate(app.dateModel[0], 'YYYY-MM-DD', 'DD/MM/YYYY'),
          app.$options.filters.formattedDate(app.dateModel[1], 'YYYY-MM-DD', 'DD/MM/YYYY')
        ]
      }
      if (parsed) {
        return app.$options.filters.formattedDate(app.dateModel, 'YYYY-MM-DD', 'DD/MM/YYYY')
      }
      return app.dateModel
    }
  },
  watch: {
    'searchTerms.boat_types' () {
      if (this.searchTerms.boat_types) {
        if ((Array.isArray(this.searchTerms.boat_types) && this.searchTerms.boat_types.length > 1) || (Array.isArray(this.searchTerms.boat_types) && this.searchTerms.boat_types.length === 0)) {
          this.form.boat_type_id = 9999
        } else if (typeof this.searchTerms.boat_types === 'number') {
          this.form.boat_type_id = this.searchTerms.boat_types
        } else if (this.searchTerms.boat_types[0] && typeof this.searchTerms.boat_types[0] === 'number') {
          this.form.boat_type_id = this.searchTerms.boat_types[0]
        }
      }
    }
  },
  created () {
    this.setPreviousParams()

    this.$nuxt.$on('onCloseDestinationInputModal', (data) => {
      if (this.$refs['search-location-input']) {
        this.$refs['search-location-input'].setSelectedListItems(data.locations)
      }
      if (this.$refs['dateSelector'] && !this.form.date && !this.$route.name === 'boat-view') {
        this.$refs['dateSelector'].setFocus()
      } else if (this.form.date) {
        if (this.boatTypeRequired && !this.form.boat_type_id) {
          this.form.errors.set('boat_type', '')
          if (this.$refs?.types?.$el) {
            this.$refs.types.openList()
          }
        } else {
          this.submit()
        }
      }
    })

    this.$nuxt.$on('dateSelected', (data) => {
      if (this.$refs['dateSelector'] && this.form.date) {
        if (this.boatTypeRequired && !this.form.boat_type_id) {
          this.form.errors.set('boat_type', '')
          if (this.$refs?.types?.$el) {
            this.$refs.types.openList()
          }
        }
      }
    })

    if (!this.$Search) {
      return
    }
    const queryBoatTypes = this.$Search.getAttributeValue('boat_types')
    if (Array.isArray(queryBoatTypes) && queryBoatTypes.length === 1) {
      this.typeModel = parseInt(queryBoatTypes[0], 10)
    }
  },
  methods: {
    SEARCH_OTHER_PAGES () {
      return SEARCH_OTHER_PAGES
    },
    setLocations (locations) {
      this.form.locations = locations
    },
    onChangeCallback (ev) {
      if (!ev[0]) {
        this.form.date = null
        this.$store.commit('search/SET_BAR', { condition: 'current', data: { date: null } })
        this.$store.commit('search/SET_DATE', null)
      }
    },
    inputClickHandler (e) {
      this.$modal.show('search-destination-input-modal', { form: this.form })
    },
    setClearedDate () {
      this.cleared.date = true
    },
    disabledBeforeToday (date) {
      return date < new Date(new Date().setHours(0, 0, 0, 0))
    },
    submit () {
      this.busy.form = true

      if (!Array.isArray(this.form.locations) || !(Array.isArray(this.form.locations) && this.form.locations?.[0]?.slug)) {
        if (this.size === 'sm' || this.size === 'x-sm') {
          this.$modal.show('search-destination-input-modal', { form: this.form })
        } else {
          this.$refs['search-location-input'].openList()
        }

        this.busy.form = false
        return
      }

      if (this.boatTypeRequired && !this.form.boat_type_id) {
        this.form.errors.set('boat_type', '')
        if (this.$refs?.types?.$el) {
          this.$refs.types.openList()
        }
        this.busy.form = false
        return
      }
      const locations = this.form.locations.map(l => l.slug).filter(Boolean)
      const urlFilters = {
        locations,
        boat_types: [this.typeModel !== 9999 ? this.typeModel : null],
        start_date: this.dateModel[0],
        duration: isValidDateFormat(this.dateModel[0]) ? this.duration : null
      }
      if (this.$route.query.companies) {
        this.$Search.defaultAttributeSetter('companies', this.$route.query.companies, true)
        urlFilters.companies = [this.$route.query.companies]
      }

      let url = this.$Search.getFiltersUrl(urlFilters, { reset: true, apply: true })
      this.$nuxt.$emit('searchStarting')
      if (['boat-view'].includes(this.$route.name)) {
        url = url.replace(/guests=[^&$]*/i, '').replace(/skipper=[^&$]*/i, '')
      }

      if (SEARCH_PAGES.includes(this.$route.name)) {
        window.history.replaceState({}, document.title, url)
        this.$Search.search()
        this.$nuxt.$emit('searchUpdated', { locations, boatType: [this.typeModel !== 9999 ? this.typeModel : null] })
        const newRoute = this.$router.resolve(url)
        this.$router.replace({ params: newRoute.route.params, query: newRoute.route.query})
      } else {
        this.$router.push(url).catch((e) => {
          console.log(e)
        })
      }

      this.submitted = false
      this.busy.form = false
    },
    onCloseDate () {
      this.cleared.date = false
    },
    getPreviousParams () {
      this.input = this.$store.getters['search/bar'].prev.location
      this.typeModel = this.$store.getters['search/bar'].prev.boat_type
      this.dateModel = this.$store.getters['search/bar'].prev.date
    },
    setPreviousParams () {
      const charterTypeFromUrl = this.$store.getters['data/chartered'].find(bt => bt.transTitle === this.$route.params.charterType)
      const dt = {
        boat_type: this.typeModel,
        location: this.input,
        date: this.dateModel
      }
      if (charterTypeFromUrl) {
        dt.charter_type = charterTypeFromUrl.transTitle
        dt.charter_type_id = charterTypeFromUrl.id
      }
      this.$store.commit('search/SET_BAR', {
        condition: 'prev',
        data: dt
      })
    }
  }
}
